import Table, { SkeletonRows, TableBody } from '@/components/Table';
import CompanyInvestorsTableHead from './CompanyInvestorsTableHead';
import CompanyInvestorRow, {
  type CompanyInvestorRowProps,
} from './CompanyInvestorRow';
import { sortByCreatedAt } from '@/utils/arrays';
import { DecoratedCompanyInvestor } from '@flemingmetrics/api-client';
import { buildCompanyInvestorKey } from '@/store/slices/companyInvestorsSlice';
import { useHasCompanyAccess } from '@/hooks/useStore';

export type CompanyInvestorsTableProps = {
  isFetchingData?: boolean;
  className?: string;
  rowType: CompanyInvestorRowProps['rowType'];
  rows: Pick<DecoratedCompanyInvestor, 'companyId' | 'investorId'>[];
};

export default function CompanyInvestorsTable({
  isFetchingData,
  className = '',
  rowType,
  rows,
}: CompanyInvestorsTableProps) {
  const hasCompanyAccess = useHasCompanyAccess();

  return (
    <Table className={className}>
      <CompanyInvestorsTableHead />
      <TableBody>
        {isFetchingData ? (
          <SkeletonRows columns={hasCompanyAccess ? 9 : 8} />
        ) : (
          sortByCreatedAt(rows).map(({ companyId, investorId }) => (
            <CompanyInvestorRow
              key={buildCompanyInvestorKey(companyId, investorId)}
              companyId={companyId}
              investorId={investorId}
              rowType={rowType}
            />
          ))
        )}
      </TableBody>
    </Table>
  );
}
